import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { ApiService } from './api.service';
import { EnrollmentBenefitCategory } from 'src/app/models/enrollment-category';
import { WidgetIFrameLoader } from 'src/app/models/widget';
import { environment } from 'src/environments/environment';

const controllerRoute = '/enrollment-widget';

@Injectable()
export class EnrollmentWidgetService {

    constructor(
        private apiService: ApiService,
    ) {
    }

    /**
     * We need to santize the url to allow browsers to use the iframe allow messages to be passed to the top page.
     * DEV: We do not want to call the widget urls. Angular only care for response messages passed up for testing.
     * @returns Sanitizeed IFrame URL 
     */
    public initializeSerivce(): Observable<WidgetIFrameLoader> {
        const l_EndURL = environment.useWidgetTestPage ? '-test' : '';
        return this.apiService.get(`${controllerRoute}/initialize${l_EndURL}`).pipe(
            map((response: WidgetIFrameLoader) => {
                return response;
            }),
        );
    }

    public getError(): Observable<EnrollmentBenefitCategory> {
        return this.apiService.get(`${controllerRoute}/error`).pipe(
            map((response: EnrollmentBenefitCategory) => {
                return response;
            }),
        );
    }

    public getFinalize(): Observable<EnrollmentBenefitCategory> {
        return this.apiService.get(`${controllerRoute}/finalize`).pipe(
            map((response: EnrollmentBenefitCategory) => {
                return response;
            }),
        );
    }
}